module.exports = __webpack_public_path__ + "images/landing/light/creativity.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/light/creativity.png
// module id = HN/J
// module chunks = 118